import React from 'react'
// import StagesManager from '../../components/StagesManager';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';

import { nanoid } from 'nanoid';
import { checkTextTranslation, imageAddress, translate } from '../../utils/useful';
import HttpServices from '../../utils/Http.services';
// import HttpServices from '../utils/Http.services'



class SearchHome extends React.Component {
    state = {}

    componentDidMount() {

    }


    openHub = (item) => {

        this.props.addNewWindow("hub", { path: [item?.username], type: 'hub' }, "center")
        this.addToSearchHistory({ type: 'hub', hub: item._id })

    }

    openApplet = (item) => {

        this.props.addNewWindow("applet", { path: [item?.hub?.username, item?.slug], type: 'applet' }, "center")
        this.addToSearchHistory({ type: 'applet', applet: item._id })

    }


    addToSearchHistory = (item) => {

        this.props.addToSearchHistory(item)

    }


    render() {

        let searchResults = this.props.searchResults

        return (

            <>
                {(Array.isArray(searchResults.hubs) && searchResults.hubs.length > 0) && (
                    <div className='br-10 bg-white box-shadow-20 mx-4 mb-4 pb-3'>

                        <div className='px-3 text-semibold pt-3 mb-2 text-normal'>
                            <p>{translate("Found hubs")}</p>
                        </div>

                        {searchResults.hubs.map((item) => {
                            return (
                                <div className='' style={{ cursor: 'pointer', }} onClick={() => { this.openHub(item) }}>
                                    <div className='w-100'>
                                        <div className='flexc pld-4'>
                                            <img src={imageAddress(item?.image, "profile", 'thumb')} style={{ width: '45px', height: '45px', borderRadius: 40, objectFit: 'cover' }} className='mrd-4' />
                                            <div className='py-2' >
                                                <p className="font-size-14 main-c2 weight-500" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{checkTextTranslation(item?.fullname)}</p>
                                                <p className="font-size-12 main-c7" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{this.props.language == 'fa' ? item?.username + '@' : '@' + item?.username}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )

                        })}
                    </div>
                )}


                {(Array.isArray(searchResults.applets) && searchResults.applets.length > 0) && (
                    <div className='br-10 bg-white box-shadow-20 mx-4 mb-4 pb-3'>

                        <div className='px-3 text-semibold pt-3 mb-2 text-normal'>
                            <p>{translate("Found applets")}</p>
                        </div>

                        {searchResults.applets.map((item) => {
                            return (
                                <div className='py-3 px-3 bb-gray' style={{ transition: 'all 0.5s', cursor: 'pointer', }} onClick={() => { this.openApplet(item) }}>
                                    <div className='flexc'>
                                        <img src={imageAddress(item?.image, "applet", 'thumb')} style={{ width: '40px', height: 40, borderRadius: 40, objectFit: 'cover' }} className='mrd-3' />
                                        <div className='w-90'>

                                            <div className=" w-100">
                                                <p className="font-size-14 text-semibold" style={{ color: '#202020', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{checkTextTranslation(item?.name)}</p>
                                                <p className="font-size-12" style={{ color: '#777', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', }}>{'@' + item?.hub?.username}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}

                    </div>
                )}



                {(!Array.isArray(searchResults.hubs) || searchResults.hubs?.length == 0) && (!Array.isArray(searchResults.applets) || searchResults.applets?.length == 0) && (
                    <div className='p-3 flexcc'>
                        <p className='font-size-14 main-c7'>{translate('Nothing found')}</p>
                        {/* <img src='/images/search/search.gif' width={320} /> */}
                    </div>
                )}

            </>
        )

    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SearchHome);